import { render, staticRenderFns } from "./handleShipment.vue?vue&type=template&id=5cd64981&scoped=true"
import script from "./handleShipment.vue?vue&type=script&lang=js"
export * from "./handleShipment.vue?vue&type=script&lang=js"
import style0 from "./handleShipment.vue?vue&type=style&index=0&id=5cd64981&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd64981",
  null
  
)

export default component.exports